import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface GarageDoorDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GarageDoorDescription: React.FC<GarageDoorDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [garageDoor, set_garageDoor] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Garage Door']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Garage Door': [v, b.values?.['Exterior Structure']?.['Garage Door']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={garageDoor}
                />
            ) : (
                <TextBox
                    value={garageDoor}
                    onChange={(value) => set_garageDoor(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
